import styled from "styled-components"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"

export const Holder = styled(motion.div)`
  position: fixed;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
`

export const Footer = styled.div`
  position: relative;
  width: 100%;
  height: 8em;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #857695;
`

export const BackButton = styled(Link)`
  position: absolute;
  left: 1em;
  top: 50%;
  transform: translateY(-50%);
`

export const Logo = styled.img`
  height: 70%;
`

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  flex: 1;
  padding: 4vw;
  &:after {
    content: "";
    background-image: url("/assets/images/about/corner.svg");
    background-size: cover;
    width: 3vw;
    height: 3vw;
    position: absolute;
    top: 1.5vw;
    left: 1.5vw;
  }
`
export const RightSection = styled.div`
  width: 40vw;
  background-image: ${({ img }) => `url(${img})`};
  background-size: cover;
  background-position: center;
`

export const TitleHolder = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #513b69;
  font-family: "Lora-Regular";
  font-weight: 300;
  font-size: 6vw;
  line-height: 98%;
  color: #857695;
`

export const TipHolder = styled.div`
  width: 80%;
  padding: 3vw 0;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 1em;
  color: #857695;
`

export const ContactHolder = styled.div`
  /* width: 100%; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1em;
`
export const ContactList = styled.ul`
  margin: 0;
  padding: 0;
`

export const ContactTitle = styled.li`
  font-style: normal;
  font-weight: bold;
  font-size: 1em;
  color: #3b1a53;
  list-style: none;
  margin-bottom: 1.5em;
`
export const ContactValue = styled.li`
  font-style: normal;
  font-size: 1em;
  color: #3b1a53;
  list-style: none;
  line-height: 150%;
`
